// components/LoadingScreen.js
import React from 'react';
import { Box, Typography } from '@mui/material';

const LoadingScreen = () => (
  <Box
    sx={{
      height: '100vh',
      width: '100vw',
      position: 'fixed',
      top: 0,
      left: 0,
      zIndex: 1300,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      backdropFilter: 'blur(8px)',
      backgroundColor: 'rgba(0, 0, 0, 0.3)', // semi-transparent
      color: '#fff',
    }}
  >
    <Box
      sx={{
        width: 80,
        height: 80,
        borderRadius: '50%',
        border: '6px solid rgba(255, 255, 255, 0.3)',
        borderTop: '6px solid #90caf9',
        animation: 'spin 1s linear infinite',
        mb: 3,
      }}
    />
    <Typography variant="h5" sx={{ fontWeight: 'bold', letterSpacing: 1.5 }}>
      Loading Udyog Connect...
    </Typography>

    <style>{`
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `}</style>
  </Box>
);

export default LoadingScreen;
